import { Checkbox } from "@mui/material";
import { ReactNode, useContext } from "react";
import { components, OptionProps } from "react-select";

import { useRtl } from "@ryde/redux";

import { StickyOptionsFocusContext } from "./sticky-option-focus.context";

export const FilterDropdownOption = (props: OptionProps): ReactNode => {
  const { isSelected } = props;
  const isStickyOptionsFocused = useContext(StickyOptionsFocusContext);
  const { direction } = useRtl();
  return (
    <components.Option
      {...props}
      isFocused={isStickyOptionsFocused ? false : props.isFocused}
    >
      <div dir={direction}>
        <Checkbox sx={{ marginInlineEnd: 2 }} checked={isSelected} />
        {props.label}
      </div>
    </components.Option>
  );
};
